import { Link } from "react-router-dom";
import { ArrowLeft, AlertTriangle } from "lucide-react";

export default function Disclaimer() {
  return (
    <div data-testid="disclaimer-page" className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="py-16 bg-[#0F392B]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-white/70 hover:text-white mb-6 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            <span className="font-body text-sm">Back to Home</span>
          </Link>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold text-white">
            Service Disclaimer
          </h1>
          <p className="font-body text-white/70 mt-4">
            Last updated: December 2025
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-[#F9F9F7]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Important Notice */}
          <div className="bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-2xl p-6 mb-8 flex gap-4">
            <AlertTriangle className="w-6 h-6 text-[#D4AF37] flex-shrink-0 mt-1" />
            <div>
              <h3 className="font-heading text-lg font-semibold text-[#0F392B] mb-2">
                Important Notice
              </h3>
              <p className="font-body text-[#4A5568] text-sm">
                Please read this disclaimer carefully before using our services.
                By using our services, you acknowledge that you have read,
                understood, and agree to the terms of this disclaimer.
              </p>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-lg prose prose-lg max-w-none">
            <h2 className="font-heading text-2xl font-semibold text-[#0F392B] mb-4">
              Tax Services Disclaimer
            </h2>
            <p className="font-body text-[#4A5568] leading-relaxed mb-6">
              Espady Multi-Service Co. provides tax preparation services to
              assist individuals and businesses in filing their tax returns. We
              are not a law firm and do not provide legal advice. Our services
              are based on the information you provide. The accuracy of your tax
              return depends on the accuracy and completeness of the information
              you supply. You are ultimately responsible for the accuracy of
              your tax returns.
            </p>
            <p className="font-body text-[#4A5568] leading-relaxed mb-6">
              We do not guarantee specific outcomes, refunds, or results. Tax
              laws and regulations are complex and subject to change. We
              recommend consulting with a licensed tax attorney or CPA for
              complex tax matters or legal tax advice.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-[#0F392B] mb-4">
              Immigration Services Disclaimer
            </h2>
            <p className="font-body text-[#4A5568] leading-relaxed mb-6">
              Our immigration form assistance services are limited to helping
              you complete forms and organize documents. We are NOT attorneys
              and do NOT provide legal advice or representation. We cannot
              guarantee approval of any immigration application or petition.
            </p>
            <p className="font-body text-[#4A5568] leading-relaxed mb-6">
              Immigration law is complex and constantly changing. For legal
              advice regarding your immigration status or options, please
              consult with a licensed immigration attorney. We strongly
              recommend seeking legal counsel for any immigration matter.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-[#0F392B] mb-4">
              Notary Services Disclaimer
            </h2>
            <p className="font-body text-[#4A5568] leading-relaxed mb-6">
              Our notary services are limited to witnessing signatures and
              administering oaths as permitted by Florida law. Notaries are
              prohibited from giving legal advice or preparing legal documents.
              We cannot advise you on what documents you need or explain the
              contents of documents you bring to us.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-[#0F392B] mb-4">
              Credit Repair Disclaimer
            </h2>
            <p className="font-body text-[#4A5568] leading-relaxed mb-6">
              Credit repair services involve reviewing your credit reports and
              assisting with dispute processes. We cannot guarantee any specific
              improvement to your credit score. Results vary based on individual
              circumstances. Only accurate information can legally be removed
              from your credit report.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-[#0F392B] mb-4">
              General Disclaimer
            </h2>
            <p className="font-body text-[#4A5568] leading-relaxed mb-6">
              The information and services provided by Espady Multi-Service Co.
              are for general informational purposes only. While we strive to
              provide accurate and up-to-date information, we make no
              warranties or representations about the completeness, accuracy,
              or reliability of any information or services.
            </p>
            <p className="font-body text-[#4A5568] leading-relaxed mb-6">
              Espady Multi-Service Co. shall not be liable for any errors,
              omissions, or any losses, injuries, or damages arising from the
              use of our services. By using our services, you agree to hold us
              harmless from any claims arising from your use of our services.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-[#0F392B] mb-4">
              Questions?
            </h2>
            <p className="font-body text-[#4A5568] leading-relaxed">
              If you have any questions about this disclaimer or our services,
              please contact us:
            </p>
            <div className="font-body text-[#4A5568] mt-4">
              <p>Espady Multi-Service Co.</p>
              <p>1368-B S Military Trail, Suite R</p>
              <p>West Palm Beach, FL 33415</p>
              <p>Phone: 786-991-8919</p>
              <p>Email: espadywisellc@gmail.com</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
